// extracted by mini-css-extract-plugin
export var banner = "_2e-0";
export var icon = "_2e-1";
export var message = "_2e-2";